<template>
  <div class="modal-header-white">
    <div class="title-wrap">
      <div class="modal-title">{{ label }}</div>
      <div
        v-if="subtitle"
        class="subtitle"
      >
        {{ subtitle }}
      </div>
    </div>
    <close-icon @click="onClosed" />
  </div>
</template>

<script>
  import ScrollUtils from 'utils/scrollUtils'
  import CloseIcon from 'components/CloseIcon'

  const events = {
    CLOSED: 'closed'
  }

  export default {
    components: {
      CloseIcon
    },
    props: {
      deviceType: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      subtitle: {
        type: String,
        default: '',
        required: false
      }
    },
    mounted () {
      if (this.deviceType === 'mobile') {
        ScrollUtils.disableScroll()
      }
    },
    destroyed () {
      ScrollUtils.enableScroll()
    },
    methods: {
      onClosed () {
        this.$emit(events.CLOSED)
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .modal-header-white {
    z-index: 5;
    position: fixed;
    top: 0;
    left: 0;
    padding: 0 55px 0 24px;
    width: 100%;
    height: 55px;
    background-color: #ffffff;
    border-bottom: 1px solid $grey-border;

    @include bp-mf-tablet {
      position: relative;
      border-radius: 6px 6px 0 0;
    }

    .modal-title {
      @include text-overflow();
      font-size: em(16);
      font-weight: 500;

      @include bp-mf-tablet {
        position: relative;
      }
    }

    .subtitle {
      font-size: em(12);
      color: $grey;
    }

    .title-wrap {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    .close-icon {
      top: 0;
      right: 26px;
      font-size: em(18);
      line-height: 55px;
      color: $blue-medium;
      z-index: 99;
    }
  }
</style>
